import { useMutation } from '@apollo/client';
import { Vehicule } from '../../shared/types';
import { CITRIN_UPDATE_VEHICULE, UpdateVehiculeRequest, UpdateVehiculeResponse } from '..';

type UpdateMutationFunction = (request: Vehicule) => Promise<Vehicule>;
export const useUpdateVehiculeMutation = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdateVehiculeResponse, UpdateVehiculeRequest>(CITRIN_UPDATE_VEHICULE);

    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_updateVehicule;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
